export default "__VITE_ASSET__B$3x3lZS__"